<template>
  <div class="c-app">
    <CContainer fluid class="bg-white min-vh-100">
      <CRow class="align-items-center min-vh-100">
        <CCol lg="8" md="12" sm="12" xs="12" class="p-0">
          <img :src="randomImage" class="cimap d-md-down-none" />
        </CCol>
        <CCol lg="4" md="12" sm="12" xs="12" class="d-flex justify-content-center align-items-center bg-white">
          <CCard class="border-0" style="max-width:100%;width:400px;">
            <CCardBody class="p-4 border-0">
              <!-- Add @submit.prevent to the form -->
              <CForm @submit.prevent="handleSubmit">
                <CSidebarBrand class="color-dark">
                  <CIcon
                    class="c-sidebar-brand-full"
                    name="logo"
                    size="custom-size"
                    :height="65"
                    viewBox="-50 0 456 104"
                  />
                  <CIcon
                    class="c-sidebar-brand-minimized"
                    name="logo"
                    size="custom-size"
                    :height="25"
                    viewBox="0 0 175 134"
                  />
                </CSidebarBrand>
              <p class="text-muted text-center">
            {{ isPortal ? 'Prihlásenie do portálu včelára' : 'Prihlásenie do Betared' }}
          </p>
                <CInput
                  placeholder="Kľúč"
                  autocomplete="Kľúč"
                  name="key"
                  v-model="model.unitID"
                >
                  <template #prepend-content>
                    <CIcon name="cil-calculator" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Prihlasovacie meno"
                  name="username"
                  autocomplete="username email"
                  v-model="model.username"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Heslo"
                  type="password"
                  autocomplete="current-password"
                  v-model="model.password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
                <CRow>
                  <CCol col="12" class="text-center">
                    <!-- Set the button type to "submit" -->
                    <CButton type="submit" color="primary" class="px-4 mt-3 w-100 ant-btn-primary">Prihlásiť</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>

export default {
  name: 'login',
  data() {
    return {
        host: window.location.hostname,
      model: {
        username: '',
        password: '',
        unitID: '',
        submitted: false
      },
       randomImage: null
    }
  },
    created() {
    const totalImages = 4; // zmeň podľa počtu obrázkov
    const index = Math.floor(Math.random() * totalImages) + 1;
    this.randomImage = require(`@/assets/images/auth/` + (this.isPortal ? `bee-` : ``) +  `img-auth-sideimg${index}.png`);
  },
  computed: {
      isPortal() {
      return this.host === 'admin.portalvcelara.sk'
    },
    isBetared() {
      return this.host === 'admin.betared.sk' || this.host === 'localhost'
    },
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    handleSubmit() {
      this.model.submitted = true;
      const { username, password, unitID } = this.model;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch('authentication/login', { username, password, unitID });
      }
    }
  }
};
</script>

<style>
.cimap {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  object-position: center bottom;
  background-color: #fff; /* alebo biela, podľa svetlosti obrázku */
}


.responsive-sizer {
  padding-bottom: 86.5278%;
  flex: 1 0 0px;
  transition: padding-bottom 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}
</style>
